<template>
   <div class="col s12 yo-bg-home">
      <h2 class="white yo-align-center yo-margin-top-s">E-LEARNING</h2>
      <div class="col s11m offset-ss">
         <p class="yo-padding-bottom-s yo-align-center yo-color-secondary-text-light">
            a selection of interactive, web-based, educational resources designed by <br />EFLM experts to improve your daily practice
         </p>
      </div>

      <div class="col s12">
         <div class="col s12 m6" style="padding: 0 2px 2px 2px">
            <router-link to="/live-webinar">
               <div class="col s12 sezione-home">
                  <div class="col s12 live-webinars yo-valign-center yo-align-center">
                     <div class="sezione-home-text">
                        <div class="col s10 offset-s1">
                           <h3 class="white">LIVE WEBINARS</h3>
                           <p class="yo-color-secondary-text-light">Watch live EFLM webinars and interact with experts</p>
                        </div>
                     </div>
                  </div>
               </div>
            </router-link>
         </div>
         <div class="col s12 m6" style="padding: 0 2px 2px 2px">
            <router-link to="/on-demand-webinar">
               <div class="col s12 sezione-home">
                  <div class="col s12 on-demand-webinars yo-valign-center yo-align-center">
                     <div class="sezione-home-text">
                        <div class="col s10 offset-s1">
                           <h3 class="white">ON-DEMAND WEBINARS</h3>
                           <p class="yo-color-secondary-text-light">Recorded videos of all past EFLM webinars</p>
                        </div>
                     </div>
                  </div>
               </div>
            </router-link>
         </div>
         <div class="col s12 m6" style="padding: 0 2px 2px 2px">
            <router-link to="/syllabus-course">
               <div class="col s12 sezione-home">
                  <div class="col s12 syllabus-course yo-valign-center yo-align-center">
                     <div class="sezione-home-text">
                        <div class="col s10 offset-s1">
                           <h3 class="white">SYLLABUS COURSE</h3>
                           <p class="yo-color-secondary-text-light">A top quality EFLM Revision Course designed to increase the knowledge and exam confidence for postgraduate students</p>
                        </div>
                     </div>
                  </div>
               </div>
            </router-link>
         </div>
         <div class="col s12 m6" style="padding: 0 2px 2px 2px">
            <router-link to="/interactive-contents">
               <div class="col s12 sezione-home">
                  <div class="col s12 interactive-contents yo-valign-center yo-align-center">
                     <div class="sezione-home-text">
                        <div class="col s10 offset-s1" >
                           <h3 class="white">INTERACTIVE CONTENTS</h3>
                           <p class="yo-color-secondary-text-light">Other EFLM educational opportunities</p>
                        </div>
                     </div>
                  </div>
               </div>
            </router-link>
         </div>
      </div>
  </div>
</template>

<script>
export default {
   name: 'home',
   data(){
      return{

      }
   },
   created(){
      document.title= "EFLM Academy Site | Home"

      var oggi= this.$luxon.now()
      oggi= oggi.plus({ days: 5 })
      console.log(oggi.weekday)
   }
}
</script>